/**
 * Extracts all file IDs from a nested data structure.
 * This function is used to collect node_ids from __files__ properties
 * that may be nested at any level within the provided data object.
 */
const extractFileIds = (data: any): string[] => {
  /**
   * Recursively traverses the data structure to find and collect file IDs
   */
  const recurse = (obj: any, result: Set<string>): void => {
    if (typeof obj === 'object' && obj !== null) {
      // If the object has a __files__ property, extract node_ids from it
      if ('__files__' in obj) {
        obj.__files__.forEach((file: { node_id: string }) =>
          result.add(file.node_id),
        );
      }

      // Continue recursion for all values in the object
      Object.values(obj).forEach((value) => recurse(value, result));
    } else if (Array.isArray(obj)) {
      // If the current value is an array, process each item
      obj.forEach((item) => recurse(item, result));
    }
  };

  // Use a Set to automatically handle uniqueness of file IDs
  const fileIds: Set<string> = new Set();
  recurse(data, fileIds);

  // Convert the Set back to an array for the return value
  return Array.from(fileIds);
};

export default extractFileIds;
